/**
 * Where each namespace's queued ops are sent (utilities/localFirst/sendOps.js), for the page and the
 * service worker. Kept apart from both so the worker imports nothing else of the app's.
 */
export const OP_ENDPOINTS = {
	food: 'food/ops',
};

/** The background sync tag the op queue asks for, and the service worker sends on. */
export const OPS_SYNC_TAG = 'localFirstOps';
